import { connect } from 'react-redux';
import { compose } from 'redux';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import withReducer from '@Hooks/withReducer';
import { open as openStructureDialog } from '@Containers/StructureDialog/StructureDialogAction';

import { alertCreateDialogReducerKey } from './AlertCreateDialogConstatns';
import alertCreateDialogsReducer from './AlertCreateDialogReducer';
import {
  isEditMode,
  isMigrateMode,
  alertsInfo,
  queryFactItem,
  description,
  structures,

  // form
  alertFormAlertName,
  alertFormEmails,
  alertFormFrequency,
  alertFormDayOfWeek,
  alertFormDayOfMonth,
  alertFormTriggerMode,
  alertFormProcessOptions,
  alertFormDatabases,

  // emails array compatible with MultiInput
  emailsMultiInput,

  // show non-owner email message
  showNonOwnerEmailMessage,

  // frequency conditional dropdowns
  alertFormDayOfWeekAvailable,
  alertFormDayOfMonthAvailable,

  // basic/advanced content databases
  basicContentDatabases,
  basicContentAvailable,
  advancedContentDatabase,

  // process options
  processOptionZeroResults,
  processOptionTitleAndBiblio,
  processOptionAbstract,
  processOptionFullAbstract,
  processOptionPartialAbstract,
  processOptionHitDetails,
  advancedValidationMessage,

  // edit query
  disableEditQuery,

  // submit form
  submitAlertFormEnabled,
} from './AlertCreateDialogSelectors';
import {
  init as initAction,
  resetAlertCreateDialog,

  // validation
  validateAlertName,
  validateEmailsInputOnChange,
  validateEmailsInputOnSelect,

  // form
  setAlertFormAlertName,
  addAlertFormEmail,
  removeAlertFormEmail,
  setAlertFormFrequency,
  setAlertFormDayOfWeek,
  setAlertFormDayOfMonth,
  setAlertFormTriggerMode,

  // basic/advanced content databases
  toggleAlertFormDatabase,
  toggleAdvancedContentDatabase,

  // process options
  toggleProcessOptionZeroResults,
  toggleProcessOptionTitleAndBiblio,
  toggleProcessOptionAbstract,
  setProcessOptionFullAbstract,
  setProcessOptionPartialAbstract,
  toggleProcessOptionHitDetails,

  // submit form
  submitAlertForm,
} from './AlertCreateDialogActions';
import AlertCreateDialog from './AlertCreateDialog';

function mapStateToProps(state, ownProps) {
  return {
    isEditMode: isEditMode(state, ownProps),
    isMigrateMode: isMigrateMode(state, ownProps),

    alertsInfo: alertsInfo(state),
    queryFactItem: queryFactItem(state),
    description: description(state),
    structures: structures(state),

    // form
    alertFormAlertName: alertFormAlertName(state),
    alertFormEmails: alertFormEmails(state),
    alertFormFrequency: alertFormFrequency(state),
    alertFormDayOfWeek: alertFormDayOfWeek(state),
    alertFormDayOfMonth: alertFormDayOfMonth(state),
    alertFormTriggerMode: alertFormTriggerMode(state),
    alertFormProcessOptions: alertFormProcessOptions(state),
    alertFormDatabases: alertFormDatabases(state),

    // emails array compatible with MultiInput
    emailsMultiInput: emailsMultiInput(state),

    // show non-owner email message
    showNonOwnerEmailMessage: showNonOwnerEmailMessage(state),

    // frequency conditional dropdowns
    alertFormDayOfWeekAvailable: alertFormDayOfWeekAvailable(state),
    alertFormDayOfMonthAvailable: alertFormDayOfMonthAvailable(state),

    // basic/advanced content databases
    basicContentDatabases: basicContentDatabases(state),
    basicContentAvailable: basicContentAvailable(state),
    advancedContentDatabase: advancedContentDatabase(state),

    // process options
    processOptionZeroResults: processOptionZeroResults(state),
    processOptionTitleAndBiblio: processOptionTitleAndBiblio(state),
    processOptionAbstract: processOptionAbstract(state),
    processOptionFullAbstract: processOptionFullAbstract(state),
    processOptionPartialAbstract: processOptionPartialAbstract(state),
    processOptionHitDetails: processOptionHitDetails(state),

    advancedValidationMessage: advancedValidationMessage(state),

    // edit query
    disableEditQuery: disableEditQuery(state),

    // submit form
    submitAlertFormEnabled: submitAlertFormEnabled(state, ownProps),
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: (...args) => dispatch(initAction(...args)),
  resetAlertCreateDialog: (...args) => dispatch(resetAlertCreateDialog(...args)),

  // validation
  validateAlertName: (alertName) => dispatch(validateAlertName(alertName, ownProps)),
  validateEmailsInputOnChange: (...args) => dispatch(validateEmailsInputOnChange(...args)),
  validateEmailsInputOnSelect: (...args) => dispatch(validateEmailsInputOnSelect(...args)),

  // form
  setAlertFormAlertName: (...args) => dispatch(setAlertFormAlertName(...args)),
  addAlertFormEmail: (...args) => dispatch(addAlertFormEmail(...args)),
  removeAlertFormEmail: (...args) => dispatch(removeAlertFormEmail(...args)),
  setAlertFormFrequency: (...args) => dispatch(setAlertFormFrequency(...args)),
  setAlertFormDayOfWeek: (...args) => dispatch(setAlertFormDayOfWeek(...args)),
  setAlertFormDayOfMonth: (...args) => dispatch(setAlertFormDayOfMonth(...args)),
  setAlertFormTriggerMode: (...args) => dispatch(setAlertFormTriggerMode(...args)),

  // basic/advanced content databases
  toggleAlertFormDatabase: (...args) => dispatch(toggleAlertFormDatabase(...args)),
  toggleAdvancedContentDatabase: (...args) => dispatch(toggleAdvancedContentDatabase(...args)),

  // process options
  toggleProcessOptionZeroResults: (...args) => dispatch(toggleProcessOptionZeroResults(...args)),
  toggleProcessOptionTitleAndBiblio: (...args) => dispatch(toggleProcessOptionTitleAndBiblio(...args)),
  toggleProcessOptionAbstract: (...args) => dispatch(toggleProcessOptionAbstract(...args)),
  setProcessOptionFullAbstract: (...args) => dispatch(setProcessOptionFullAbstract(...args)),
  setProcessOptionPartialAbstract: (...args) => dispatch(setProcessOptionPartialAbstract(...args)),
  toggleProcessOptionHitDetails: (...args) => dispatch(toggleProcessOptionHitDetails(...args)),

  // open structure
  openStructureDialog: (...args) => dispatch(openStructureDialog(...args)),

  // submit form,
  submitAlertForm: () => dispatch(submitAlertForm(ownProps)),
});

// export default compose(
//   withReducer(alertCreateDialogReducerKey, alertCreateDialogsReducer),
//   connect(mapStateToProps, mapDispatchToProps),
//   lifecycle({
//     componentDidMount() {
//       const { alert, databaseId, init } = this.props;
//       init(alert, databaseId);
//     },
//     componentWillUnmount() {
//       const { resetAlertCreateDialog } = this.props;
//       resetAlertCreateDialog();
//     },
//   })
// )(AlertCreateDialog);

function AlertCreateDialogContainer(props) {
  const { alert, databaseId, init } = props;
  useEffect(() => {
    init(alert, databaseId);
    return () => {
      resetAlertCreateDialog();
    };
  }, [alert, databaseId, init]);

  return <AlertCreateDialog {...props} />;
}

AlertCreateDialogContainer.propTypes = {
  alert: PropTypes.any,
  databaseId: PropTypes.string,
  init: PropTypes.func,
  resetAlertCreateDialog: PropTypes.func,
};

const EnhancedAlertCreateDialogContainer = compose(
  withReducer(alertCreateDialogReducerKey, alertCreateDialogsReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(AlertCreateDialogContainer);

export default EnhancedAlertCreateDialogContainer;
